export default __webpack_public_path__ + "static/media/heart.cb4e77b5.svg";